import { cms } from '@/cms';
import ArticleItem from './RelatedArticleItem';
import ImageStrapi from '../../atoms/Image/ImageStrapi';
import RichTextFieldStrapi from '../../atoms/RichTextField/RichTextFieldStrapi';

export const ArticleItemStrapi = async ({
  slug,
  size,
}: {
  slug: string;
  size?: 'small' | 'large';
}) => {
  const { data } = await cms.getBlogBySlug(slug);
  if (!data) {
    return null;
  }

  const {
    author,
    description,
    image,
    newUntil,
    releaseDate,
    timeSpentReading,
    title,
    topics,
  } = data.attributes.metadata;

  const isNew = newUntil ? new Date(newUntil) > new Date() : false;

  return (
    <ArticleItem
      slug={slug}
      size={size}
      image={image}
      releaseDate={releaseDate}
      timeSpentReading={timeSpentReading}
      isNew={isNew}
      herotitle={title}
      description={<RichTextFieldStrapi block={description} />}
      author={{
        image: (
          <ImageStrapi
            block={author?.data?.attributes.image ?? {}}
            inner={{ classNames: { image: ' w-9 rounded-full' } }}
            width={36}
            height={36}
          />
        ),
        name: author?.data?.attributes.name,
        authorPageSlug: author?.data?.attributes.authorPageSlug,
      }}
      topics={
        topics?.data?.map((topic) => ({
          topic: topic.attributes.topic,
          slug: topic.attributes.slug,
        })) ?? []
      }
    />
  );
};
